<template>
    <div
        v-if="selectedFilters.length"
        class="m-selectedFilters d-flex align-items-center"
    >
        <h4 class="m-selectedFilters__heading mb-0 font-weight-medium">
            Wybrane filtry
        </h4>
        <div class="m-selectedFilters__filters">
            <div
                v-for="(n, index) in showAll
                    ? selectedFilters.length
                    : numberOfVisibleLabels"
                :key="index"
            >
                <filter-label
                    v-if="selectedFilters[index]"
                    :key="index"
                    :text="selectedFilters[index].text.toString()"
                    :backgroundColor="selectedFilters[index].backgroundColor"
                    :color="selectedFilters[index].color"
                    :class="selectedFilters[index].customClass"
                    @close="clearFilter(selectedFilters[index])"
                />
            </div>
            <filter-label
                v-if="
                    !showAll && selectedFilters.length > numberOfVisibleLabels
                "
                :text="`+${selectedFilters.length - numberOfVisibleLabels}`"
                :close="false"
                @click.native="showAll = true"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        filters: {
            type: Object,
            required: true
        },
        moduleName: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            numberOfVisibleLabels: 6,
            showAll: false
        }
    },
    /* eslint-disable */
    computed: {
        selectedFilters() {
            const filters = []
            Object.values(this.filters).forEach((filter, idx) => {
                if (filter.value && !filter.hidden) {
                    let additionalText = ''
                    if (filter.additionalText) {
                        additionalText =
                            '<strong>' + filter.additionalText + ':</strong> '
                    }

                    const getter = filter.options || this.$store.getters[filter.getter]
                    
                    const filterData = {
                        backgroundColor: filter.backgroundColor,
                        color: filter.color,
                        customClass: filter.customClass,
                        filter: Object.keys(this.filters)[idx]
                    }
                    if (
                        typeof filter.value === 'object' &&
                        Object.values(filter.value)
                    ) {
                        if (filter.value.length && getter && getter.length) {
                            filter.value.forEach(v => {
                                filters.push({
                                    text:
                                        additionalText +
                                        (getter.find(el => el.value === v) !==
                                        undefined
                                            ? getter.find(el => el.value === v)
                                                  .label
                                            : ''),
                                    value: v,
                                    groupName: filter.groupName,
                                    ...filterData
                                })
                            })
                        }
                    } else if (filter.type === 'search-input') {
                        let text = additionalText
                        text += filter.value
                        filters.push({
                            text: text,
                            value: filter.value,
                            ...filterData
                        })
                    } else if (
                        typeof filter.value === 'string' ||
                        typeof filter.value === 'number' ||
                        filter.type === 'radio'
                    ) {
                        let text = additionalText
                        if (filter.options && filter.options.length) {
                            text += filter.options.find(
                                el => el.value === filter.value
                            ).label
                        } else if (getter && getter.length) {
                            text += getter.find(el => el.value === filter.value)
                                .label
                        } else if (filter.value) {
                            const format = 'YYYY-MM-DD HH:mm:ss'
                            if (
                                this.$moment(
                                    filter.value,
                                    format,
                                    true
                                ).isValid()
                            ) {
                                filter.value = this.$moment(
                                    filter.value
                                ).format('DD-MM-YYYY')
                            }

                            const formatRangeRegex = /^[0-9]{4}-[0-9]{2}-[0-9]{2}(,[0-9]{4}-[0-9]{2}-[0-9]{2})*$/
                            let rangeDates = ''
                            if (formatRangeRegex.test(filter.value)) {
                                const dates = filter.value.split(',')
                                const convertedDates = `${this.$moment(
                                    dates[0]
                                ).format('DD-MM-YYYY')} - ${this.$moment(
                                    dates[1]
                                ).format('DD-MM-YYYY')}`
                                rangeDates = convertedDates
                            }
                            text += rangeDates ? rangeDates : filter.value
                        } else {
                            return
                        }
                        filters.push({
                            text: text,
                            value: filter.value,
                            ...filterData
                        })
                    } else {
                        filters.push({
                            text:
                                additionalText +
                                (getter
                                    ? getter.find(
                                          el => el.value === filter.value
                                      ).label
                                    : filter.text
                                    ? filter.text
                                    : filter.value),
                            value: filter.value,
                            ...filterData
                        })
                    }
                }
            })
            return filters
        }
    },
    /* eslint-enable */
    methods: {
        async clearFilter(selectedFilter) {
            const { filter, value, groupName = false } = selectedFilter

            const moduleFilter = this.filters[filter]

            let newValue
            if (typeof moduleFilter.value === 'object') {
                newValue = moduleFilter.value.filter(el => el !== value)
            } else if (typeof moduleFilter.value === 'boolean') {
                newValue = false
            } else {
                newValue = null
            }

            await this.$store.dispatch('setFilter', {
                filter,
                value: newValue,
                moduleName: this.moduleName,
                groupName
            })

            if (moduleFilter.noRefetch) {
                return
            }

            this.applyFilters(filter, newValue)
        },
        applyFilters(filter, value) {
            return this.$emit('applyFilters', {
                filter,
                value
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../../styles/_custom.scss';
@import '~bootstrap/scss/mixins';

.m-selectedFilters {
    align-items: flex-start;
    margin-bottom: 1rem;
    gap: 0.5rem;

    &__heading {
        font-size: 1.25rem;
    }

    &__filters {
        display: flex;
        flex-wrap: wrap;
        grid-gap: 0.5rem;
    }

    @include media-breakpoint-down(sm) {
        flex-wrap: wrap;
    }
}
</style>
